import { alpha, Box, Stack, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';

export interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export const EmptyState = (props: EmptyStateProps) => {
  const theme = useTheme();

  return (
    <Stack alignItems="center" spacing={2} py={8} px={4}>
      <Box
        aria-hidden="true"
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: alpha(theme.palette.primary.light, 0.2),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {props.icon}
      </Box>
      <Stack spacing={1} alignItems="center">
        <Typography variant="h6" fontWeight="bold" textAlign="center">
          {props.title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="center"
          maxWidth={280}
        >
          {props.description}
        </Typography>
      </Stack>
    </Stack>
  );
};
